/**
 * FAQ Component
 * アコーディオン機能
 */

class FAQComponent {
  constructor() {
    this.init();
  }

  init() {
    this.faqItems = document.querySelectorAll('.p-faq__item');
    this.bindEvents();
  }

  bindEvents() {
    this.faqItems.forEach(item => {
      const question = item.querySelector('.p-faq__question');
      if (question) {
        question.addEventListener('click', () => this.toggleFAQ(item));
      }
    });
  }

  toggleFAQ(item) {
    const question = item.querySelector('.p-faq__question');
    const answer = item.querySelector('.p-faq__answer');
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      // 閉じる
      item.classList.remove('is-open');
      question.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = '0';
    } else {
      // 開く
      item.classList.add('is-open');
      question.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  new FAQComponent();
});